export default { sha: 'a96c71f5db7290e3edf6d35936f33a05fbef831c', buildNumber: 'undefined' }
